export var isMediaRecorderAvailable = function isMediaRecorderAvailable() {
  return window.MediaRecorder !== undefined;
};